
import { Component, Vue } from 'vue-property-decorator'
import BaseVue from '@/components/BaseVue'
import appBar from '@/components/AppBar.vue'
import { EditCondition } from '../models/EmpPasswordCondition'

@Component({
	components: { appBar }
})
export default class EmoloyeeMasterEditView extends BaseVue {
	//#region 変数

	private editCondition: EditCondition = new EditCondition()
	private eventNm = ''
    private showPassword = false

	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

	//#endregion

	//#region 初期表示イベント
	private async created() {
		this.editCondition.empCd = this.$route.params.empcd
		this.getEmp()

		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 保存ボタン押下
	private async save() {
		//メッセージクリア
		this.messageClear()

		const data = {
			EditCondition: this.editCondition
		}

		try {
			const response = await this.$axios.post('api/EmployeePasswordEdit/Edit', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getEmp()
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#endregion

	//#region 閉じるボタン押下
	private close() {
		this.$router.push({ name: 'Menu' })
	}
	//#endregion

	//#region プライベート

	//#region 従業員情報取得
	private async getEmp() {
		try {
			const data = { EditCondition: this.editCondition }

			const response = await this.$axios.post('api/EmployeePasswordEdit/Get', data)

			this.editCondition = response.data.editCondition

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion


	//#region メッセージクリア
	private messageClear() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

	//#endregion
}
